import * as React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

interface AttendanceChartProps {
  attendedCount: number;
  absencesCount: number;
  notOccurredCount: number;
}

export const AttendanceChart = ({
  attendedCount,
  absencesCount,
  notOccurredCount,
}: AttendanceChartProps): React.JSX.Element => {
  const data = [
    { name: 'Attended', value: attendedCount, color: '#28a745' },
    { name: 'Absent', value: absencesCount, color: '#dc3545' },
    { name: 'No Session', value: notOccurredCount, color: '#6c757d' },
  ];

  // Filter out zero values for cleaner display
  const filteredData = data.filter((entry) => entry.value > 0);

  const COLORS = filteredData.map((entry) => entry.color);

  const renderCustomLabel = (entry: any) => {
    const total = filteredData.reduce((sum, item) => sum + item.value, 0);
    const percentage = total > 0 ? ((entry.value / total) * 100).toFixed(1) : '0';
    return `${entry.name}: ${entry.value} (${percentage}%)`;
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={filteredData}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={renderCustomLabel}
          outerRadius={100}
          fill="#8884d8"
          dataKey="value"
        >
          {filteredData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};
